import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4 d-flex align-items-center" }
const _hoisted_7 = { class: "form-check form-switch mt-3" }
const _hoisted_8 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_9 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_10 = ["min"]
const _hoisted_11 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = {
  key: 0,
  class: "p-3 bg-light rounded-3 mb-4 d-flex align-items-center gap-3"
}
const _hoisted_14 = { class: "fw-semibold text-dark" }
const _hoisted_15 = { class: "text-primary" }
const _hoisted_16 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Price Tier' : 'Add Price Tier',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-lg-12 mb-3" }, [
              _createElementVNode("div", { class: "alert alert-info fs-13 py-2" }, [
                _createElementVNode("i", { class: "ri-information-line me-1" }),
                _createTextVNode(" Set the page range for this tier. Use "),
                _createElementVNode("strong", null, "Max Pages = empty"),
                _createTextVNode(" to create an open-ended tier (e.g., \"51+ pages\"). Prices are automatically assigned to TRANSLATE orders based on the customer's submitted page count. ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Label", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.label) = $event)),
                placeholder: "e.g. 1 – 10 halaman"
              }, null, 512), [
                [_vModelText, _ctx.form.label]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted" }, "Friendly display name shown to users.", -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isActive",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.is_active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.is_active]
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "isActive"
                }, "Active (available for new orders)", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, [
                _createTextVNode("Min Pages "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.min_pages) = $event)),
                min: "1",
                placeholder: "1",
                required: ""
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.min_pages,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Max Pages", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.max_pages) = $event)),
                min: _ctx.form.min_pages,
                placeholder: "Leave empty for unlimited (∞)"
              }, null, 8, _hoisted_10), [
                [
                  _vModelText,
                  _ctx.form.max_pages,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("small", { class: "text-muted" }, "Leave blank for open-ended tier.", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, [
                _createTextVNode("Price (IDR) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "input-group-text bg-light text-muted" }, "Rp", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.price) = $event)),
                  min: "0",
                  step: "1000",
                  placeholder: "150000",
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.price,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("small", { class: "text-muted" }, "Flat fee for orders in this page range.", -1))
            ])
          ]),
          (_ctx.form.price)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "ri-price-tag-3-line fs-20 text-primary" }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "fs-13 text-muted" }, "Preview", -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.form.label || `${_ctx.form.min_pages}–${_ctx.form.max_pages ?? '∞'} halaman`) + " → ", 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatPrice(_ctx.form.price)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_RouterLink, {
              to: "/translate-price-tiers",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Tier' : 'Create Tier'), 1)
            ], 8, _hoisted_17)
          ])
        ], 32)
      ])
    ])
  ]))
}